import React, { useState, useEffect } from 'react';

const EmployeeProfileReport = () => {
  const [employeeData, setEmployeeData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [employeeId, setEmployeeId] = useState('');

  // Extract employee ID from URL or use default value
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const empId = urlParams.get('employeeId') || 'RAMRAJ';
    setEmployeeId(empId);
  }, []);

  // Function to call the API (replace with your actual API endpoint)
  const fetchEmployeeData = async () => {
    setLoading(true);
    setError(null);
    
    try {
      // Replace with your actual API endpoint
      const response = await fetch(`https://www.nissi-india.com/api/employee_profile/${employeeId}`);
      console.log("Employee ID:", employeeId);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log("response:", data);
      setEmployeeData(data.data || {});
    } catch (err) {
      setError(err.message);
      console.error('Error fetching employee data:', err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch data when component mounts or employee ID changes
  useEffect(() => {
    if (employeeId) {
      fetchEmployeeData();
    }
  }, [employeeId]);

  // Sample data to match the screenshot
  const sampleData = {
    branch: "HEAD OFFICE",
    grossSalary: "71900",
    empId: "",
    dailyBata: "0",
    mobileNumber: "9940345678",
    specialHRA: "15968",
    conveyanceAllowance: "4485.00",
    employeeName: "RAMRAJ",
    employeeCode: "",
    bloodGroup: "B +",
    designation: "CNC OPERATOR",
    department: "CNC DEPARTMENT",
    dateOfJoining: "01 Feb 2019",
    fatherName: "",
    accountNumber: "1234567",
    gender: "Male",
    bankName: "KVB",
    country: "India",
    state: "Tamil Nadu",
    district: "",
    city: "",
    maritalStatus: "Single",
    preExperienceYears: "0",
    dateOfBirth: "",
    preExperienceMonths: "0",
    qualifications: "",
    yearOfCompletion: "",
    drivingLicenseNumber: "",
    drivingLicenseExpiryDate: "",
    pf: "Yes",
    pfNumber: "01",
    shift: "Day",
    esiNumber: "567855345",
    esi: "",
    grade: "EXECUTIVE",
    panNumber: "1243",
    salaryBasis: "Monthly",
    voterId: "",
    aadharCardNumber: "",
    ifscCode: ""
  };

  // Use sample data if no API data is available
  const data = Object.keys(employeeData).length > 0 ? employeeData : sampleData;

  return (
    <div className="max-w-4xl mx-auto p-4 bg-white font-sans text-sm print:p-0 print:max-w-none">
      {/* Header Section */}
      <div className="border-2 border-black mb-0">
        <div className="border-b border-black flex">
          {/* Logo Section */}
          <div className="w-24 border-r border-black p-2 flex items-center justify-center">
            <div className="bg-black text-white px-2 py-1 text-xs font-bold text-center">
              <div>NISSI</div>
              <div>INFOTECH PVT LTD</div>
            </div>
          </div>
          
          {/* Company Info Section */}
          <div className="flex-1 p-2">
            <div className="text-center">
              <h1 className="text-lg font-bold mb-1">Nissi Infotech</h1>
              <div className="text-xs">
                <div>Nissi</div>
                <div className="font-bold">CIVIL CONSTRUCTION</div>
                <div>3/42-12, Nagappa colony, kavundampalayam,641600, Tamil Nadu, India.</div>
                <div>Phone No: 9003744644 infraconsoft-implementation@nissi</div>
              </div>
            </div>
          </div>
          
          {/* Photo Section */}
          <div className="w-24 border-l border-black p-2 flex items-center justify-center">
            <div className="w-20 h-24 border border-gray-400 flex items-center justify-center text-xs text-orange-500 bg-gray-50">
              <div className="text-center">
                <div>No Image</div>
                <div>Help</div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Employee Details Row */}
        <div className="border-b border-black">
          <div className="grid grid-cols-4 gap-0 text-xs">
            <div className="border-r border-black p-2">
              <div className="flex">
                <span className="w-20">Branch</span>
                <span className="mx-2">:</span>
                <span>{data.branch}</span>
              </div>
            </div>
            <div className="border-r border-black p-2">
              <div className="flex">
                <span className="w-20">Gross Salary</span>
                <span className="mx-2">:</span>
                <span>{data.grossSalary}</span>
              </div>
            </div>
            <div className="border-r border-black p-2">
              <div className="flex">
                <span className="w-16">Emp ID</span>
                <span className="mx-2">:</span>
                <span>{data.empId}</span>
              </div>
            </div>
            <div className="p-2">
              <div className="flex">
                <span className="w-16">Daily Bata</span>
                <span className="mx-2">:</span>
                <span>{data.dailyBata}</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-b border-black">
          <div className="grid grid-cols-2 gap-0 text-xs">
            <div className="border-r border-black p-2">
              <div className="flex">
                <span className="w-24">Mobile Number</span>
                <span className="mx-2">:</span>
                <span>{data.mobileNumber}</span>
              </div>
            </div>
            <div className="p-2">
              <div className="flex">
                <span className="w-32">Special HRA</span>
                <span className="mx-2">:</span>
                <span>{data.specialHRA}</span>
              </div>
            </div>
          </div>
        </div>
        
        <div>
          <div className="text-xs p-2">
            <div className="flex">
              <span className="w-32">Conveyance Allowance</span>
              <span className="mx-2">:</span>
              <span>{data.conveyanceAllowance}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Loading/Error States */}
      {loading && (
        <div className="text-center py-4">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-black"></div>
          <div className="mt-2">Loading employee data...</div>
        </div>
      )}

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
          <div className="font-bold">Error loading employee data:</div>
          <div>{error}</div>
          <button 
            onClick={fetchEmployeeData}
            className="mt-2 bg-red-600 text-white px-3 py-1 rounded text-xs hover:bg-red-700"
          >
            Retry
          </button>
        </div>
      )}

      {/* Basic Details Section */}
      <div className="border-l-2 border-r-2 border-b border-black">
        <div className="bg-gray-100 border-b border-black px-2 py-1 font-bold text-xs">
          BASIC DETAILS
        </div>
        <div className="grid grid-cols-2 gap-0 text-xs">
          <div className="border-r border-black">
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-24">Employee Name</span>
              <span className="mx-2">:</span>
              <span className="font-semibold">{data.employeeName}</span>
            </div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-24">Blood Group</span>
              <span className="mx-2">:</span>
              <span>{data.bloodGroup}</span>
            </div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-24">Department</span>
              <span className="mx-2">:</span>
              <span>{data.department}</span>
            </div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-24">Father Name</span>
              <span className="mx-2">:</span>
              <span>{data.fatherName}</span>
            </div>
            <div className="flex p-2">
              <span className="w-24">Gender</span>
              <span className="mx-2">:</span>
              <span>{data.gender}</span>
            </div>
          </div>
          <div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-24">Employee Code</span>
              <span className="mx-2">:</span>
              <span>{data.employeeCode}</span>
            </div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-24">Designation</span>
              <span className="mx-2">:</span>
              <span>{data.designation}</span>
            </div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-24">Date of Joining</span>
              <span className="mx-2">:</span>
              <span>{data.dateOfJoining}</span>
            </div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-24">Account Number</span>
              <span className="mx-2">:</span>
              <span>{data.accountNumber}</span>
            </div>
            <div className="flex p-2">
              <span className="w-24">Bank Name</span>
              <span className="mx-2">:</span>
              <span>{data.bankName}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Details Section */}
      <div className="border-l-2 border-r-2 border-b border-black">
        <div className="bg-gray-100 border-b border-black px-2 py-1 font-bold text-xs">
          CONTACT DETAILS
        </div>
        <div className="grid grid-cols-2 gap-0 text-xs">
          <div className="border-r border-black">
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-24">Permanent Address</span>
              <span className="mx-2">:</span>
              <span></span>
            </div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-24">Country</span>
              <span className="mx-2">:</span>
              <span>{data.country}</span>
            </div>
            <div className="flex p-2">
              <span className="w-24">District</span>
              <span className="mx-2">:</span>
              <span>{data.district}</span>
            </div>
          </div>
          <div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-24">Temporary Address</span>
              <span className="mx-2">:</span>
              <span></span>
            </div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-24">State</span>
              <span className="mx-2">:</span>
              <span>{data.state}</span>
            </div>
            <div className="flex p-2">
              <span className="w-24">City</span>
              <span className="mx-2">:</span>
              <span>{data.city}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Personal Details Section */}
      <div className="border-l-2 border-r-2 border-b border-black">
        <div className="bg-gray-100 border-b border-black px-2 py-1 font-bold text-xs">
          PERSONAL DETAILS
        </div>
        <div className="grid grid-cols-2 gap-0 text-xs">
          <div className="border-r border-black">
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-24">Marital status</span>
              <span className="mx-2">:</span>
              <span>{data.maritalStatus}</span>
            </div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-24">Date of Birth</span>
              <span className="mx-2">:</span>
              <span>{data.dateOfBirth}</span>
            </div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-24">Qualifications</span>
              <span className="mx-2">:</span>
              <span>{data.qualifications}</span>
            </div>
            <div className="flex p-2">
              <span className="w-24">Driving License Number</span>
              <span className="mx-2">:</span>
              <span>{data.drivingLicenseNumber}</span>
            </div>
          </div>
          <div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-24">Pre Experience Year(s)</span>
              <span className="mx-2">:</span>
              <span>{data.preExperienceYears}</span>
            </div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-24">Pre Experience Months</span>
              <span className="mx-2">:</span>
              <span>{data.preExperienceMonths}</span>
            </div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-24">Year of Completion</span>
              <span className="mx-2">:</span>
              <span>{data.yearOfCompletion}</span>
            </div>
            <div className="flex p-2">
              <span className="w-24">Driving License Expiry Date</span>
              <span className="mx-2">:</span>
              <span>{data.drivingLicenseExpiryDate}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Status Section */}
      <div className="border-l-2 border-r-2 border-b-2 border-black">
        <div className="bg-gray-100 border-b border-black px-2 py-1 font-bold text-xs">
          STATUS
        </div>
        <div className="grid grid-cols-2 gap-0 text-xs">
          <div className="border-r border-black">
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-16">PF</span>
              <span className="mx-2">:</span>
              <span>{data.pf}</span>
            </div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-16">Shift</span>
              <span className="mx-2">:</span>
              <span>{data.shift}</span>
            </div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-16">E.S.I</span>
              <span className="mx-2">:</span>
              <span>{data.esi}</span>
            </div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-16">P.A.N Number</span>
              <span className="mx-2">:</span>
              <span>{data.panNumber}</span>
            </div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-16">Voter ID</span>
              <span className="mx-2">:</span>
              <span>{data.voterId}</span>
            </div>
            <div className="flex p-2">
              <span className="w-16">IFSC Code</span>
              <span className="mx-2">:</span>
              <span>{data.ifscCode}</span>
            </div>
          </div>
          <div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-20">PF Number</span>
              <span className="mx-2">:</span>
              <span>{data.pfNumber}</span>
            </div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-20">E.SI Number</span>
              <span className="mx-2">:</span>
              <span>{data.esiNumber}</span>
            </div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-20">Grade</span>
              <span className="mx-2">:</span>
              <span>{data.grade}</span>
            </div>
            <div className="flex p-2 border-b border-gray-300">
              <span className="w-20">Salary Basis</span>
              <span className="mx-2">:</span>
              <span>{data.salaryBasis}</span>
            </div>
            <div className="flex p-2">
              <span className="w-20">Aadhar Card Number</span>
              <span className="mx-2">:</span>
              <span>{data.aadharCardNumber}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-4 text-xs text-gray-600 border border-gray-300 p-2 bg-gray-50">
        Report Created by infraconsoft version 2.1 www.infraconsoft.com
      </div>

      {/* Print Styles */}
      <style jsx>{`
        @media print {
          body { margin: 0; }
          .print\\:hidden { display: none !important; }
          .print\\:p-0 { padding: 0 !important; }
          .print\\:max-w-none { max-width: none !important; }
          @page { 
            margin: 0.5in; 
          }
        }
      `}</style>
    </div>
  );
};

export default EmployeeProfileReport;